import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
export class GaugeStylingModel extends CoreStylingModel {

  gauge: StylingModel;

  value: StylingModel;

  prefix: StylingModel;

  suffix: StylingModel;

  label: StylingModel;
/**
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
    if (this.gauge == null) { this.gauge = new StylingModel(); }
    if (this.value == null) { this.value = new StylingModel(); }
    if (this.prefix == null) { this.prefix = new StylingModel(); }
    if (this.suffix == null) { this.suffix = new StylingModel(); }
    if (this.label == null) { this.label = new StylingModel(); }
  }
}

function GaugeStylingModel_tsickle_Closure_declarations() {
/** @type {?} */
GaugeStylingModel.prototype.gauge;
/** @type {?} */
GaugeStylingModel.prototype.value;
/** @type {?} */
GaugeStylingModel.prototype.prefix;
/** @type {?} */
GaugeStylingModel.prototype.suffix;
/** @type {?} */
GaugeStylingModel.prototype.label;
}

